import { render, staticRenderFns } from "./MachineSoftware.vue?vue&type=template&id=3d13fcdd&scoped=true"
import script from "./MachineSoftware.vue?vue&type=script&lang=js"
export * from "./MachineSoftware.vue?vue&type=script&lang=js"
import style0 from "./MachineSoftware.vue?vue&type=style&index=0&id=3d13fcdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d13fcdd",
  null
  
)

export default component.exports